// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".loading-container[data-v-57b5bd16] .ant-spin-dot-item{background-color:#fff!important}.loading-container[data-v-57b5bd16] .ant-spin{color:#fff!important}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
